import { useCallback, useEffect } from "react";
import { StatusBar } from "expo-status-bar";
import { Navigation } from "./navigation";
import { SafeAreaProvider } from "react-native-safe-area-context";
import { useFonts } from "expo-font";
import * as SplashScreen from "expo-splash-screen";
import ContextProviders from "./context/Provider";
import { QueryClientProvider } from "react-query";
import queryClient from "./services/reactQuery";
import { LogBox, TextInput, Text } from "react-native";
import Toast from "react-native-toast-message";
import { LogLevel, OneSignal } from "react-native-onesignal";
import { Platform } from "react-native";
import { Provider as PaperProvider, DefaultTheme } from "react-native-paper";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import * as Clarity from "@microsoft/react-native-clarity";
import _Clarity from "@microsoft/clarity";

if (Platform.OS !== "web") {
  OneSignal.Debug.setLogLevel(LogLevel.Verbose);
  OneSignal.initialize("efbd84e2-ce83-49bb-a340-dbde79afab1b");

  // Also need enable notifications to complete OneSignal setup
  OneSignal.Notifications.requestPermission(true);
}

if (Platform.OS === "web") {
  _Clarity.init("q7vcgydbj9");
} else {
  Clarity.initialize("s64zmv1uwf");
}

SplashScreen.preventAutoHideAsync();

const theme = {
  ...DefaultTheme,
  colors: {
    ...DefaultTheme.colors,
    primary: "#2C3E50",
    accent: "#3498db",
  },
  dark: false,
};

export default function App() {
  const [fontsLoaded] = useFonts({
    NunitoExtraLight: require("./assets/fonts/Nunito-ExtraLight.ttf"),
    NunitoLight: require("./assets/fonts/Nunito-Light.ttf"),
    NunitoRegular: require("./assets/fonts/Nunito-Regular.ttf"),
    NunitoMedium: require("./assets/fonts/Nunito-Medium.ttf"),
    NunitoSemiBold: require("./assets/fonts/Nunito-SemiBold.ttf"),
    NunitoBold: require("./assets/fonts/Nunito-Bold.ttf"),
    NunitoExtraBold: require("./assets/fonts/Nunito-ExtraBold.ttf"),
    NunitoBlack: require("./assets/fonts/Nunito-Black.ttf"),
  });

  const onLayoutRootView = useCallback(async () => {
    if (fontsLoaded) {
      await SplashScreen.hideAsync();
    }
  }, [fontsLoaded]);

  if (!fontsLoaded) {
    return null;
  }

  if (Text.defaultProps == null) Text.defaultProps = {};
  Text.defaultProps.allowFontScaling = false;
  Text.defaultProps.maxFontSizeMultiplier = 1;

  if (TextInput.defaultProps == null) TextInput.defaultProps = {};
  TextInput.defaultProps.allowFontScaling = false;
  TextInput.defaultProps.maxFontSizeMultiplier = 1;

  LogBox.ignoreLogs(["VirtualizedLists should never be nested"]);
  LogBox.ignoreLogs(["Constants"]);
  LogBox.ignoreLogs(["You are attempting"]);
  LogBox.ignoreLogs(["expo-notifications"]);

  return (
    <PaperProvider
      theme={theme}
      settings={{
        icon: (props) => <MaterialCommunityIcons {...props} />,
      }}
    >
      <SafeAreaProvider onLayout={onLayoutRootView}>
        <QueryClientProvider client={queryClient}>
          <ContextProviders>
            <Navigation />
            <StatusBar backgroundColor={"#fff"} />
            <Toast />
          </ContextProviders>
        </QueryClientProvider>
      </SafeAreaProvider>
    </PaperProvider>
  );
}
